import { render, staticRenderFns } from "./PagSeguro3DS.vue?vue&type=template&id=583134e5"
import script from "./PagSeguro3DS.vue?vue&type=script&lang=js"
export * from "./PagSeguro3DS.vue?vue&type=script&lang=js"
import style0 from "./PagSeguro3DS.vue?vue&type=style&index=0&id=583134e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports